"use strict";

const _definitions = {
  0.5: {
    certainty: "Low confidence",
    source: "Auto-populated property values",
    description:
      "A property boundary is established and the system has auto-populated property values from available datasets. These values have not yet been reviewed.",
  },
  1: {
    certainty: "Low confidence",
    source: "Default assumptions reviewed",
    description:
      "Some auto-populated values have been verified or refined using readily-available information. Estimates rely on default assumptions and represent a reasonable starting point for property assessment.",
  },
  1.5: {
    certainty: "Between low and moderate confidence",
    source: "Site evaluation in progress",
    description:
      "Default assumptions have been reviewed, and site-level evaluation of the property is underway. Completing the site evaluation typically supports a move to Moderate.",
  },
  2: {
    certainty: "Moderate confidence",
    source: "Desktop analysis",
    description:
      "Property data has been refined through desktop analysis of site conditions and stormwater context. Estimates reflect property-specific characteristics rather than defaults, with a level of rigor appropriate for early-stage planning.",
  },
  2.5: {
    certainty: "Between moderate and high confidence",
    source: "Asset-level refinement in progress",
    description:
      "Desktop analysis is complete, and refinement of stormwater asset specifications and associated estimates is underway. Completing this work typically supports a move to High.",
  },
  3: {
    certainty: "High confidence",
    source: "Site evaluation and field surveys",
    description:
      "Property data reflects on-the-ground evaluation and refined stormwater asset details. Cost, performance, and cost-recovery estimates are well-characterized and appropriate for active investment planning.",
  },
  3.5: {
    certainty: "Between high and very high confidence",
    source: "Engineering analysis in progress",
    description:
      "Asset-level data is in place, and engineering analysis is underway. Completing it typically supports a move to Very high.",
  },
  4: {
    certainty: "Very high confidence",
    source: "Engineering analysis",
    description:
      "Property data reflects engineering-grade analysis. Cost, investment, and impact values are highly accurate and appropriate for construction, reporting, and cost-recovery commitments.",
  },
};

const _getDefinition = function (value) {
  return _definitions[value];
};

const DataRichnessModal = function () {
  let $modal;
  let propertySlug;

  const render = async function (slug) {
    propertySlug = slug;
    const data = await EsgApiCalls.getProperty(slug);
    const dataRichness = data.dataRichness;
    const propertyName = data.propertyIdentifier;
    const hasBoundary = !!data.geom;
    const dropClasses = DataRichness.getDropClasses(dataRichness);
    $modal = $("#data-richness-modal");
    $modal.html(
      nunjucks.render("esg/modals/dataRichnessModal.njk", {
        propertyName,
        dataRichness,
        dropClasses,
        definition: _getDefinition(dataRichness),
        hasBoundary,
      }),
    );
    _loadListeners();
    $modal.modal("show");
  };

  const _loadListeners = function () {
    $modal.off();
    $modal.find("[value='cancel']").on("click", () => $modal.modal("hide"));
    $modal.find("[value='save']").on("click", _save);
    $modal.find("[name='dataRichness']").on("input", function () {
      const value = parseFloat($(this).val());
      _updateDynamicContent(value);
      _updatePaintedSlider(value);
    });
    _updatePaintedSlider(parseFloat($modal.find("[name='dataRichness']").val()));
  };

  const _updateDynamicContent = function (value) {
    const dropClasses = DataRichness.getDropClasses(value);
    const definition = _getDefinition(value);
    $modal
      .find(".data-richness-drops")
      .html(nunjucks.render("esg/modals/dataRichnessDropsDynamic.njk", { dropClasses }));
    $modal
      .find(".data-richness-dynamic")
      .html(nunjucks.render("esg/modals/dataRichnessModalDynamic.njk", { definition }));
  };

  const _updatePaintedSlider = function (value) {
    const pct = value / 4;
    const $paintedSlider = $modal.find(".data-richness-slider .painted-slider");
    $paintedSlider.find(".fill").css("width", pct * 100 + "%");
    $paintedSlider.find(".thumb").css({
      left: pct * 100 + "%",
      transform: pct > 0 ? "translateX(-50%)" : "translateX(0%)",
    });
    $modal.find(".drops-label").text(value + (value === 1 ? " drop" : " drops"));
  };

  const _save = async function () {
    const value = parseFloat($modal.find("[name='dataRichness']").val());
    $modal.modal("hide");
    const formData = Form.toFormData({
      id: propertySlug,
      updates: { dataRichness: value },
    });
    await EsgApiCalls.updateProperty(formData);
    await PageController.refresh();
  };

  return {
    render,
    _updateDynamicContent,
  };
};

module.exports = DataRichnessModal();

const DataRichness = require("../dataRichness");
const EsgApiCalls = require("../esgApiCalls");
const Form = require("../../general/form");
const PageController = require("../pageController");
